import * as React from 'react';

import { cn } from '@/lib/utils';

function Label({ className, ...props }: React.ComponentProps<'label'>) {
  return (
    <label
      data-slot="label"
      className={cn(
        'tw:flex tw:items-center tw:gap-2 tw:text-sm tw:leading-none tw:font-medium tw:text-foreground tw:select-none tw:group-data-[disabled=true]:pointer-events-none tw:group-data-[disabled=true]:opacity-50 tw:peer-disabled:cursor-not-allowed tw:peer-disabled:opacity-50 tw:peer-data-disabled:cursor-not-allowed tw:peer-data-disabled:opacity-50 tw:data-disabled:opacity-50 tw:data-disabled:cursor-not-allowed',
        className
      )}
      {...props}
    />
  );
}

export { Label };
